import $ from 'jquery';

export default (options) =>
{
    const defaults =
    {
        form: false,
        data: false,
        validation:
        {
            type: 'form',
            input: false
        },
        url: false,
        callbacks:
        {
            before: false,
            done: false,
            fail: false,
            always: false
        }
    };
    options = Object.assign(defaults, options);

    const $form = options.form;
    options.url = (options.url) ? options.url : $form.data('form-url');

    if (!options.data)
    {
        options.data = $form.serialize();
        switch (options.validation.type)
        {
            case 'single-input':
            {
                options.data += '&onlyValidateField=' + $(options.validation.input).attr('name').split('[').pop().split(']').shift();
                break;
            }
        }
    }

    if (options.callbacks.before) {
        options.callbacks.before();
    }

    const request = $.post(options.url, options.data);

    request.done((response) =>
    {
        const { status, data, redirectURL } = response;

        if (status === 'redirect') {
            window.location.href = redirectURL;
        }

        /* DEFAULT VALIDATION HANDLER - START */

        const errorStatementTemplate = {
            render: (errors) => {
                const makeErrorItem = (errorMsg) => `
                    <li>${errorMsg}</li>
                `;

                return `
                    <div class="gl-error-pocket shift-margin_1-vertical">
                        <ul class="text-color_red-size_tiny">
                            ${errors.map((errorMsg) => makeErrorItem(errorMsg)).join('')}
                        </ul>
                    </div>
                `;
            }
        };

        if (status === 'ok')
        {
            if (options.validation.type === 'single-input')
            {
                const { valid } = data;

                if (typeof valid !== 'undefined') {
                    const $fieldset = $(options.validation.input).parents('fieldset');
                    const $errorStatament = $fieldset.find('.gl-error-pocket');

                    $errorStatament.remove();

                    if (!valid) {
                        $fieldset.append(errorStatementTemplate.render(data.errors));
                    }

                    $fieldset.removeClass('gl-correct-input gl-error-input');

                    if ($fieldset.find('input[type="text"], input[type="password"], input[type="email"]').length) {
                        $fieldset.addClass(valid ? 'gl-correct-input' : 'gl-error-input');
                    }
                }
            }
        }
        else if (status === 'error')
        {
            const errorSpecific = data.errors.specific;

            if (typeof errorSpecific !== 'undefined' && errorSpecific !== '') {
                const errorSpecificKeys = Object.keys(errorSpecific);

                $form.find('.gl-error-pocket').remove();
                $form.find('input[name]').each((key, element) => {
                    const $element = $(element);

                    if(errorSpecificKeys.indexOf($(element).attr('name')) === -1) {
                        $element.parents('fieldset').removeClass('gl-error-input').addClass('gl-correct-input');
                    }
                });

                $.each(errorSpecific, (key, val) => {
                    const $input = $form.find(`input[name="${key}"]`);
                    const $fieldset = $input.parents('fieldset');

                    $fieldset.append(errorStatementTemplate.render(val));

                    if ($fieldset.find('input[type="text"], input[type="password"], input[type="email"]').length) {
                        $fieldset.addClass('gl-error-input');
                    }
                });
            }
        }

        /* DEFAULT VALIDATION HANDLER - END */

        if (options.callbacks.done) {
            options.callbacks.done(response);
        }
    });

    request.fail((response) =>
    {
        if (status === 'redirect') {
            window.location.href = response.redirectURL;
        }
        if (options.callbacks.fail) {
            options.callbacks.fail(response);
        }
    });

    request.always((response) =>
    {
        if (options.callbacks.always) {
            options.callbacks.always(response);
        }
    });
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/form-send.js